import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import * as React from 'react';
import { BlockContextProvider } from './BlockContext';
export function Block(props) {
  if (isEnabledBlock(props)) {
    var children = props.children,
      contextProps = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/React.createElement(BlockContextProvider, contextProps, children);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.children);
}
function isEnabledBlock(props) {
  return !!props.blockRID && !!props.view;
}